import React, { useState, useRef } from "react";

import { useTable, usePagination, useGlobalFilter } from "react-table";

import ProspectHeader from "../ProspectHeader";

import Footer from "./Footer";

const Table = ({ columns, data, totalRecords, addOnOpen, onBulkOpen }) => {
  // Use the state and functions returned from useTable to build your UI

  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const tableInstance = useRef(null);

  const handlePreviousPage = () => {
    setPageIndex((prevIndex) => Math.max(prevIndex - 1, 1));
  };

  const handleNextPage = () => {
    setPageIndex((prevIndex) => Math.min(prevIndex + 1, pageCount));
  };

  const handlegotoPage = (page) => {
    setPageIndex((prevIndex) => Math.max(page));
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    // gotoPage,
    // nextPage,
    // previousPage,

    state: { getGlobalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: pageIndex },
      manualPagination: true,
      pageCount: Math.ceil(totalRecords / pageSize),
    },
    useGlobalFilter,
    usePagination
  );

  // Render the UI for your table
  return (
    <>
      {/* <pre>
        <code>
          {JSON.stringify(
            {
              pageIndex,
              pageSize,
              pageCount,
              canNextPage,
              canPreviousPage,
            },
            null,
            1
          )}
        </code>
      </pre> */}
      <ProspectHeader
        addOnOpen={addOnOpen}
        onBulkOpen={onBulkOpen}
        filter={getGlobalFilter}
        setFilter={setGlobalFilter}
      />
      <div style={{ overflow: "auto", height: "400px" }}>
        <table
          {...getTableProps()}
          className="prospect-table"
          ref={tableInstance}
        >
          <thead className="th">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Footer
        tableInstance={tableInstance.current}
        page={page}
        gotoPage={handlegotoPage}
        previousPage={handlePreviousPage}
        nextPage={handleNextPage}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageCount={pageCount}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        setPageSize={setPageSize}
        pageSize={pageSize}
      />
    </>
  );
};

export default Table;
